import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HorizonInsights } from '../lead-horizon-tracking.model';

/**
 * Buyer Interest Insights on the lead's Horizon tab.
 *
 * What this one buyer's property activity says about what they want, plus the AI insight and next
 * action. Every row comes from the backend and a row it cannot support arrives as null, so a missing
 * row is hidden here and never filled in with a guess.
 */
@Component({
  selector: 'app-horizon-buyer-insights',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './horizon-buyer-insights.component.html',
  styleUrls: ['../horizon-card.scss', './horizon-buyer-insights.component.scss'],
})
export class HorizonBuyerInsightsComponent {
  @Input() insights: HorizonInsights | null = null;
  @Input() isLoading = false;
  @Input() hasLoadError = false;

  get topPropertyType(): string | null {
    return this.insights?.property_types_viewed?.[0]?.type ?? null;
  }

  /**
   * The AI box is always drawn once loading ends. With no reading from the backend (no property
   * activity, or the response predates the AI) it says so, rather than leaving the panel without it.
   */
  get ai(): { status: string; text: string | null; recommended_action: string | null } {
    return this.insights?.ai_insight ?? { status: 'insufficient_data', text: null, recommended_action: null };
  }

  get hasAnyRow(): boolean {
    const insights = this.insights;
    return !!(insights?.preferred_configuration || insights?.preferred_floors || insights?.price_range_viewed || this.topPropertyType);
  }
}
